export const categories = [
  { slug: "zhenrenxiu", name: "真人秀", icon: "ri-user-star-line", description: "明星真人秀综艺节目，真实记录明星生活与挑战" },
  { slug: "gaoxiao", name: "搞笑综艺", icon: "ri-emotion-laugh-line", description: "轻松搞笑综艺节目，让你笑到停不下来" },
  { slug: "yinle", name: "音乐综艺", icon: "ri-music-line", description: "音乐竞演、歌唱比赛类综艺节目" },
  { slug: "fangtan", name: "访谈综艺", icon: "ri-chat-1-line", description: "深度访谈、人物对话类综艺节目" },
  { slug: "jingsai", name: "竞技综艺", icon: "ri-trophy-line", description: "体育竞技、游戏挑战类综艺节目" },
  { slug: "tuokouxiu", name: "脱口秀", icon: "ri-mic-line", description: "脱口秀、相声小品等语言类综艺" },
  { slug: "lvxing", name: "旅行综艺", icon: "ri-earth-line", description: "明星旅行、户外探险类综艺节目" },
  { slug: "shenghuo", name: "生活综艺", icon: "ri-home-heart-line", description: "美食、家居、生活体验类综艺节目" },
];

export const heroSlides = [
  {
    id: 1,
    title: "奔跑吧·第十季",
    subtitle: "十季经典传承，全新阵容再出发！每周五晚20:00热血开跑",
    category: "真人秀",
    imageUrl: "https://readdy.ai/api/search-image?query=Dynamic%20variety%20show%20scene%20with%20energetic%20cast%20running%20on%20city%20streets%2C%20bright%20daytime%20lighting%2C%20cinematic%20wide%20shot%2C%20warm%20color%20palette%20with%20red%20and%20orange%20tones%2C%20modern%20Chinese%20urban%20setting%2C%20high%20energy%20atmosphere%2C%20professional%20television%20production%20quality&width=1800&height=900&seq=hero-running-man-s10&orientation=landscape",
  },
  {
    id: 2,
    title: "脱口秀大会·第六季",
    subtitle: "笑声不断，段子手们的巅峰对决！全新赛制更刺激",
    category: "脱口秀",
    imageUrl: "https://readdy.ai/api/search-image?query=Stand-up%20comedy%20stage%20with%20spotlight%20on%20single%20performer%2C%20theatrical%20warm%20lighting%20with%20red%20curtains%20background%2C%20microphone%20on%20stand%2C%20modern%20entertainment%20venue%20atmosphere%2C%20dramatic%20stage%20lighting%20with%20amber%20and%20coral%20tones%2C%20professional%20show%20production&width=1800&height=900&seq=hero-talk-show-s6&orientation=landscape",
  },
  {
    id: 3,
    title: "向往的生活·第八季",
    subtitle: "回归田园，慢享生活。明星嘉宾共度悠闲时光",
    category: "生活综艺",
    imageUrl: "https://readdy.ai/api/search-image?query=Peaceful%20countryside%20pastoral%20scene%20with%20traditional%20Chinese%20courtyard%20house%2C%20warm%20golden%20hour%20sunlight%2C%20lush%20green%20vegetation%2C%20rustic%20wooden%20furniture%2C%20serene%20natural%20atmosphere%2C%20soft%20bokeh%20background%2C%20lifestyle%20photography%20style%20with%20warm%20earthy%20tones&width=1800&height=900&seq=hero-back-to-field-s8&orientation=landscape",
  },
];

interface Show {
  id: number;
  title: string;
  category: string;
  imageUrl: string;
  rating: number;
  updateInfo: string;
  views: string;
  description?: string;
}

export const hotShows: Show[] = [
  {
    id: 1,
    title: "奔跑吧·第十季",
    category: "真人秀",
    imageUrl: "https://readdy.ai/api/search-image?query=Variety%20show%20promotional%20poster%20with%20vibrant%20red%20and%20coral%20color%20scheme%2C%20energetic%20group%20of%20celebrities%20posing%20dynamically%2C%20bold%20typography%2C%20modern%20Chinese%20entertainment%20design%20style%2C%20glossy%20finish%2C%20professional%20photography&width=600&height=800&seq=hot-running-man&orientation=portrait",
    rating: 9.2,
    updateInfo: "更新至第8期",
    views: "2.3亿",
    description: "《奔跑吧》第十季强势回归！全新明星阵容集结，热血挑战再度开启。本季加入更多创新游戏环节，带你体验前所未有的欢乐与感动。",
  },
  {
    id: 2,
    title: "脱口秀大会·第六季",
    category: "脱口秀",
    imageUrl: "https://readdy.ai/api/search-image?query=Stand-up%20comedy%20show%20poster%20with%20microphone%20center%20stage%2C%20warm%20amber%20spotlight%20effect%2C%20dark%20theatrical%20background%2C%20modern%20minimalist%20design%2C%20bold%20Chinese%20typography%2C%20professional%20entertainment%20industry%20style&width=600&height=800&seq=hot-talk-show&orientation=portrait",
    rating: 8.9,
    updateInfo: "更新至第10期",
    views: "1.8亿",
    description: "《脱口秀大会》第六季笑料升级！全国顶尖脱口秀演员齐聚一堂，用幽默解构生活，用段子治愈心灵。全新突围赛制，精彩不容错过！",
  },
  {
    id: 3,
    title: "向往的生活·第八季",
    category: "生活综艺",
    imageUrl: "https://readdy.ai/api/search-image?query=Pastoral%20lifestyle%20show%20poster%20with%20warm%20natural%20lighting%2C%20traditional%20countryside%20setting%2C%20fresh%20vegetables%20and%20flowers%2C%20wooden%20textures%2C%20cozy%20atmosphere%2C%20soft%20color%20palette%20with%20green%20and%20warm%20earth%20tones%2C%20natural%20lifestyle%20photography&width=600&height=800&seq=hot-back-to-field&orientation=portrait",
    rating: 9.0,
    updateInfo: "更新至第6期",
    views: "1.5亿",
    description: "《向往的生活》第八季暖心回归！新蘑菇屋坐落山水之间，明星嘉宾回归田园，自给自足，享受慢生活。每一帧都是治愈系风景。",
  },
  {
    id: 4,
    title: "歌手·巅峰之夜",
    category: "音乐综艺",
    imageUrl: "https://readdy.ai/api/search-image?query=Music%20competition%20grand%20finale%20poster%2C%20dramatic%20stage%20with%20colorful%20lighting%20effects%2C%20golden%20and%20crimson%20tones%2C%20professional%20concert%20photography%20style%2C%20grand%20scale%20production%2C%20emotional%20performance%20atmosphere&width=600&height=800&seq=hot-singer-final&orientation=portrait",
    rating: 9.5,
    updateInfo: "全12期完结",
    views: "3.1亿",
    description: "《歌手》巅峰之夜震撼来袭！华语乐坛顶级歌手同台竞技，用声音征服舞台。每一首歌都是经典，每一场演出都是传奇。",
  },
  {
    id: 5,
    title: "密室大逃脱·第五季",
    category: "竞技综艺",
    imageUrl: "https://readdy.ai/api/search-image?query=Mystery%20escape%20room%20show%20poster%20with%20dramatic%20lighting%2C%20puzzle%20elements%20and%20locked%20door%20motifs%2C%20dark%20atmospheric%20setting%20with%20warm%20accent%20lights%2C%20suspenseful%20thriller%20aesthetic%2C%20modern%20entertainment%20design&width=600&height=800&seq=hot-escape-room&orientation=portrait",
    rating: 8.7,
    updateInfo: "更新至第7期",
    views: "1.2亿",
    description: "《密室大逃脱》第五季烧脑来袭！全新密室设计更加精妙，明星玩家智勇双全闯关解密。紧张刺激中不乏欢笑，让你欲罢不能！",
  },
  {
    id: 6,
    title: "花儿与少年·丝路季",
    category: "旅行综艺",
    imageUrl: "https://readdy.ai/api/search-image?query=Travel%20variety%20show%20poster%20with%20exotic%20landscapes%2C%20warm%20desert%20tones%20and%20blue%20sky%2C%20group%20of%20travelers%20in%20stylish%20casual%20wear%2C%20golden%20hour%20lighting%2C%20adventure%20and%20friendship%20theme%2C%20cinematic%20travel%20photography&width=600&height=800&seq=hot-flowers-youth&orientation=portrait",
    rating: 8.8,
    updateInfo: "更新至第9期",
    views: "1.6亿",
    description: "《花儿与少年》丝路季踏上丝绸之路！明星嘉宾穿越千年古道，领略异域风情。有欢笑、有感动、有冒险，一路风景一路歌。",
  },
];

export const latestShows: Show[] = [
  {
    id: 7,
    title: "喜剧之王·单口季",
    category: "搞笑综艺",
    imageUrl: "https://readdy.ai/api/search-image?query=Comedy%20show%20poster%20with%20bright%20red%20stage%20curtains%2C%20single%20spotlight%20on%20empty%20stage%2C%20warm%20theatrical%20lighting%2C%20modern%20Chinese%20comedy%20club%20aesthetic%2C%20playful%20and%20energetic%20visual%20style&width=600&height=800&seq=latest-comedy-king&orientation=portrait",
    rating: 8.5,
    updateInfo: "更新至第3期",
    views: "5800万",
  },
  {
    id: 8,
    title: "乘风破浪的姐姐·第四季",
    category: "音乐综艺",
    imageUrl: "https://readdy.ai/api/search-image?query=Female%20empowerment%20variety%20show%20poster%20with%20glamorous%20stage%20setting%2C%20elegant%20golden%20lighting%2C%20confident%20women%20in%20stylish%20outfits%2C%20modern%20entertainment%20photography%2C%20coral%20and%20gold%20color%20scheme&width=600&height=800&seq=latest-sisters-wave&orientation=portrait",
    rating: 9.1,
    updateInfo: "更新至第5期",
    views: "2.7亿",
  },
  {
    id: 9,
    title: "王牌对王牌·第九季",
    category: "搞笑综艺",
    imageUrl: "https://readdy.ai/api/search-image?query=Entertainment%20game%20show%20poster%20with%20colorful%20playful%20design%2C%20red%20and%20gold%20festive%20elements%2C%20celebrity%20teams%20facing%20off%2C%20dynamic%20action%20poses%2C%20bright%20studio%20lighting%2C%20Chinese%20variety%20show%20style&width=600&height=800&seq=latest-ace-vs-ace&orientation=portrait",
    rating: 8.6,
    updateInfo: "更新至第11期",
    views: "1.9亿",
  },
  {
    id: 10,
    title: "心动的信号·第七季",
    category: "真人秀",
    imageUrl: "https://readdy.ai/api/search-image?query=Romance%20reality%20show%20poster%20with%20soft%20pink%20and%20warm%20lighting%2C%20elegant%20interior%20setting%2C%20romantic%20atmosphere%2C%20modern%20dating%20show%20aesthetic%2C%20dreamy%20bokeh%20background%2C%20sophisticated%20visual%20style&width=600&height=800&seq=latest-heart-signal&orientation=portrait",
    rating: 8.3,
    updateInfo: "更新至第8期",
    views: "1.1亿",
  },
  {
    id: 11,
    title: "令人心动的offer·第五季",
    category: "真人秀",
    imageUrl: "https://readdy.ai/api/search-image?query=Career%20reality%20show%20poster%20with%20modern%20office%20setting%2C%20professional%20atmosphere%2C%20warm%20corporate%20lighting%2C%20young%20professionals%20in%20business%20attire%2C%20clean%20modern%20design%2C%20aspirational%20visual%20style&width=600&height=800&seq=latest-exciting-offer&orientation=portrait",
    rating: 9.3,
    updateInfo: "更新至第6期",
    views: "9800万",
  },
  {
    id: 12,
    title: "我们的歌·第五季",
    category: "音乐综艺",
    imageUrl: "https://readdy.ai/api/search-image?query=Music%20collaboration%20show%20poster%20with%20elegant%20stage%20design%2C%20golden%20microphone%20center%2C%20warm%20theatrical%20lighting%2C%20classical%20and%20modern%20fusion%20aesthetic%2C%20grand%20production%20atmosphere&width=600&height=800&seq=latest-our-song&orientation=portrait",
    rating: 8.9,
    updateInfo: "更新至第8期",
    views: "1.3亿",
  },
];

export const funnyShows: Show[] = [
  {
    id: 13,
    title: "吐槽大会·第六季",
    category: "脱口秀",
    imageUrl: "https://readdy.ai/api/search-image?query=Roast%20comedy%20show%20poster%20with%20humorous%20design%20elements%2C%20bright%20red%20and%20yellow%20color%20palette%2C%20cartoonish%20speech%20bubbles%2C%20playful%20typography%2C%20energetic%20comedy%20club%20atmosphere&width=600&height=800&seq=funny-roast-s6&orientation=portrait",
    rating: 8.8,
    updateInfo: "更新至第7期",
    views: "1.4亿",
  },
  {
    id: 14,
    title: "欢乐喜剧人·第八季",
    category: "搞笑综艺",
    imageUrl: "https://readdy.ai/api/search-image?query=Comedy%20competition%20show%20poster%20with%20theatrical%20red%20curtain%2C%20golden%20spotlight%2C%20traditional%20Chinese%20comedy%20elements%2C%20festive%20atmosphere%2C%20professional%20stage%20production%20photography&width=600&height=800&seq=funny-comedian-s8&orientation=portrait",
    rating: 8.4,
    updateInfo: "更新至第9期",
    views: "1.1亿",
  },
  {
    id: 15,
    title: "一年一度喜剧大赛·第三季",
    category: "搞笑综艺",
    imageUrl: "https://readdy.ai/api/search-image?query=Sketch%20comedy%20competition%20poster%20with%20colorful%20playful%20design%2C%20multiple%20small%20stage%20vignettes%2C%20theatrical%20masks%20element%2C%20bright%20warm%20lighting%2C%20creative%20typography%2C%20energetic%20performance%20atmosphere&width=600&height=800&seq=funny-annual-comedy-s3&orientation=portrait",
    rating: 8.7,
    updateInfo: "更新至第5期",
    views: "9200万",
  },
  {
    id: 16,
    title: "德云社相声专场",
    category: "搞笑综艺",
    imageUrl: "https://readdy.ai/api/search-image?query=Traditional%20Chinese%20cross-talk%20performance%20poster%2C%20red%20stage%20with%20traditional%20decorations%2C%20two%20performers%20in%20traditional%20Chinese%20attire%2C%20warm%20theatrical%20lighting%2C%20classical%20entertainment%20atmosphere%2C%20cultural%20heritage%20style&width=600&height=800&seq=funny-deyun-cross-talk&orientation=portrait",
    rating: 9.0,
    updateInfo: "更新至第12期",
    views: "7600万",
  },
];

export const allShows: Show[] = [...hotShows, ...latestShows, ...funnyShows];

interface Article {
  id: number;
  title: string;
  summary: string;
  author: string;
  date: string;
  readTime: string;
  imageUrl: string;
}

export const featuredArticles: Article[] = [
  {
    id: 101,
    title: "《奔跑吧》第十季：经典IP的创新突围之路",
    summary: "作为国内最长寿的户外真人秀之一，《奔跑吧》在第十季迎来全面升级。本文深度解析节目如何在保持经典元素的同时，实现内容创新与年轻化表达。",
    author: "综艺观察员",
    date: "2026-07-28",
    readTime: "8分钟",
    imageUrl: "https://readdy.ai/api/search-image?query=In-depth%20analysis%20article%20illustration%20with%20modern%20editorial%20design%2C%20warm%20red%20and%20coral%20tones%2C%20abstract%20geometric%20patterns%2C%20professional%20magazine%20layout%20style%2C%20sophisticated%20visual%20storytelling%20aesthetic&width=800&height=450&seq=article-running-analysis&orientation=landscape",
  },
  {
    id: 102,
    title: "2026年Q3综艺市场趋势：真人秀与脱口秀双雄争霸",
    summary: "随着暑期档的到来，综艺市场迎来新一轮竞争。真人秀和脱口秀两大品类持续领跑，音乐综艺蓄势待发。本文带你一览2026年Q3综艺市场全景。",
    author: "行业分析师",
    date: "2026-07-25",
    readTime: "10分钟",
    imageUrl: "https://readdy.ai/api/search-image?query=Market%20trend%20analysis%20illustration%20with%20modern%20data%20visualization%20style%2C%20warm%20amber%20and%20coral%20color%20scheme%2C%20abstract%20chart%20elements%2C%20professional%20business%20magazine%20aesthetic%2C%20clean%20minimalist%20design&width=800&height=450&seq=article-market-trend&orientation=landscape",
  },
  {
    id: 103,
    title: "从《向往的生活》看慢综艺的治愈力量",
    summary: "在快节奏的都市生活中，慢综艺以其独特的治愈属性俘获了无数观众的心。《向往的生活》第八季如何延续这份温暖？让我们一同探讨慢综艺的魅力所在。",
    author: "文化评论人",
    date: "2026-07-22",
    readTime: "6分钟",
    imageUrl: "https://readdy.ai/api/search-image?query=Lifestyle%20article%20illustration%20with%20peaceful%20pastoral%20scene%2C%20warm%20golden%20hour%20lighting%2C%20soft%20natural%20tones%2C%20cozy%20cottage%20aesthetic%2C%20editorial%20photography%20style%2C%20serene%20and%20contemplative%20atmosphere&width=800&height=450&seq=article-slow-variety&orientation=landscape",
  },
];